module.exports = __webpack_public_path__ + "static/ISO-27001-780d5f0b7da587a60e241aae4442ad52.svg";